import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=219f7757&scoped=true&"
import script from "./RecoverPassword.vue?vue&type=script&lang=js&"
export * from "./RecoverPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=219f7757&prod&lang=scss&scoped=true&"
import style1 from "./RecoverPassword.vue?vue&type=style&index=1&id=219f7757&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f7757",
  null
  
)

export default component.exports